import { render, staticRenderFns } from "./AreaDataChart.vue?vue&type=template&id=4557a316&scoped=true&"
import script from "./AreaDataChart.vue?vue&type=script&lang=js&"
export * from "./AreaDataChart.vue?vue&type=script&lang=js&"
import style0 from "./AreaDataChart.vue?vue&type=style&index=0&id=4557a316&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4557a316",
  null
  
)

export default component.exports